import { Injectable } from '@angular/core';
import { Subject, Subscription } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    private registry: Map<any, Map<string, Subscription>> = new Map();
    private events: Map<string, Subject<any>> = new Map();

    constructor() { }

    public subscribe(self: any, topic: string, handler: Function): void {
        if (!this.registry.has(self)) {
            this.registry.set(self, new Map());
        }

        if (!this.events.has(topic)) {
            this.events.set(topic, new Subject());
        }

        const topics = this.registry.get(self);
        if (topics.has(topic)) {
            console.warn("Already registered <" + topic + "> for this object");
        } else {
            const sub = this.events.get(topic).subscribe((data: any[]) => handler.apply(self, data));
            topics.set(topic, sub);
        }
    }

    public subscribeAll(self: any, topics: any[][]): void {
        topics.forEach(topic => this.subscribe(self, topic[0], topic[1]));
    }

    public publish(topic: string, ...eventData: any[]): void {
        // console.log("publishing >>>>>> ", topic);
        if (this.events.has(topic)) {
            this.events.get(topic).next(eventData);
        }
    }

    public unsubscribe(self: any, topic: string): void {
        if (this.registry.has(self)) {
            const topics = this.registry.get(self);
            if (topics.has(topic)) {
                topics.get(topic).unsubscribe();
                topics.delete(topic);
            }
        }
    }

    public unsubscribeAll(self: any): void {
        if (this.registry.has(self)) {
            this.registry.get(self).forEach((sub: Subscription) => sub.unsubscribe());
            this.registry.delete(self);
        }
    }
}
